module.exports = __webpack_public_path__ + "images/hero-campaign-bg-mobile.jpg";